import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { getCookie } from "../shared/helpers";
import { fetchUserProfile } from "../redux/actions";
import Loader from "../components/Loading/Loader";

const getStoredUserProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("userProfile") || "{}") || {};
  } catch {
    return {};
  }
};

export const LoginRoute = (props) => {
  const isAuth = props.auth != null || getCookie("token") != null;
  if (!isAuth) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  return <Route {...props} />;
};

export const RestrictLoginRoute = (props) => {
  const authToken = useSelector((state) => state.authReducer.user.authToken);
  return !authToken ? (
    <Route {...props} />
  ) : (
    <Redirect
      to={{
        pathname: "/employerdashboard",
        state: { from: props.location },
      }}
    />
  );
};

export const SignupRoute = (props) => {
  const userProfile = getStoredUserProfile();
  const WizardFlow = userProfile
    ? (userProfile.WizardFlow ?? userProfile?.Profiles?.WizardFlow)
    : null;

  const isAuth = props.auth != null || getCookie("token") != null;

  if (!isAuth) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.location },
        }}
      />
    );
  }
  if (WizardFlow == null || WizardFlow < 1000) {
    return <Route {...props} />;
  }
  return <Redirect to="/employerdashboard" />;
};

export const ValidateRoute = (props) => {
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.authReducer.user.authToken);
  const WizardFlow = useSelector((state) => state.profileReducer?.user?.WizardFlow);
  const profileLoading = useSelector((state) => state.profileReducer?.loading);
  const profileRequestedRef = useRef(false);
  const userProfile = getStoredUserProfile();
  const isChildAccount = userProfile?.MasterAccountId != null;

  const wizardFlowMissing = WizardFlow == null || WizardFlow === "";
  const shouldRedirectToAuth =
    authToken && !isChildAccount && WizardFlow <= 700 && WizardFlow !== 6;

  useEffect(() => {
    console.warn("[AuthLoopDebug][ValidateRoute] route evaluation", {
      pathname: window?.location?.pathname,
      provider: localStorage.getItem("lastUsedProvider"),
      hasReduxToken: Boolean(authToken),
      hasCookieToken: Boolean(getCookie("token")),
      wizardFlow: WizardFlow,
      wizardFlowMissing,
      masterAccountId: userProfile?.MasterAccountId,
      isChildAccount,
      profileLoading,
      profileRequested: profileRequestedRef.current,
      shouldRedirectToAuth,
    });
  }, [
    authToken,
    WizardFlow,
    wizardFlowMissing,
    userProfile?.MasterAccountId,
    isChildAccount,
    profileLoading,
    shouldRedirectToAuth,
  ]);

  useEffect(() => {
    if (!authToken || !wizardFlowMissing || profileRequestedRef.current) return;
    profileRequestedRef.current = true;
    console.warn("[AuthLoopDebug][ValidateRoute] fetching profile because WizardFlow is missing", {
      pathname: window?.location?.pathname,
      provider: localStorage.getItem("lastUsedProvider"),
    });
    dispatch(fetchUserProfile(authToken));
  }, [authToken, wizardFlowMissing, dispatch]);

  if (
    authToken &&
    wizardFlowMissing &&
    (!profileRequestedRef.current || profileLoading)
  ) {
    return <Loader />;
  }

  return shouldRedirectToAuth ? (
    <Redirect to="/auth" />
  ) : (
    <Route {...props} />
  );
};
